import { IButtonStyles, ITooltipHostStyles, memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { snackbarZIndex } from 'common/components/Notifications/Snackbar';

const size = 42;

// High z-index but lower than snackbar:
const zIndex = snackbarZIndex - 1;

const radius = {
  borderRadius: '100% !important',
};

export const inlineBlockStyle: Partial<ITooltipHostStyles> = {
  root: { display: 'inline-block' },
};

export const wrapperStyles = {
  position: 'fixed' as const,
  height: size,
  width: size,
  zIndex,
  flexShrink: '0 !important',

  // from Figma:
  bottom: 32,
  right: 24,
};

export const getStyles = memoizeFunction((customStyles?: IButtonStyles) =>
  mergeStyleSets(
    {
      root: {
        ...radius,
        flexShrink: '0 !important',
        height: size,
        width: size,
        padding: '12px !important',

        '&:focus::after': {
          ...radius,
        },
      },
    } as IButtonStyles,
    customStyles
  )
);
